import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '../imports'
import styles from '../styles.scss'

class Clock extends Component {
    static pad(number) {
        const result = `0${number}`
        return result.substr(result.length - 2)
    }

    constructor(props) {
        super(props)

        // Set initial state of clock to 00:00
        this.state = { hours: '00', minutes: '00' }
    }

    componentDidMount() {
        // Update time every second
        // https://stackoverflow.com/a/19519701/404479
        // This would propably best be put in redux state so the entire application can know
        window.setInterval(() => {
            this.setTime()
        }, 1000)
    }

    setTime() {
        // Initialize the current date
        const currentDate = new Date()

        // Retrieve the values
        let hours = currentDate.getUTCHours()
        let minutes = currentDate.getUTCMinutes()

        // Stringify values to add a zero value
        // between 00 and 09
        hours = Clock.pad(hours)
        minutes = Clock.pad(minutes)

        // The visible time has not changed
        if (hours === this.state.hours && minutes === this.state.minutes) return

        // Update the state for hours and minutes
        this.setState({
            hours,
            minutes,
        })
    }

    render() {
        return (
            <Tooltip content={this.props.tooltipText}>
                <div className={styles.eveTime}>
                    {this.state.hours}:{this.state.minutes}
                </div>
            </Tooltip>
        )
    }
}

Clock.propTypes = {
    tooltipText: PropTypes.string,
}

export default Clock



// WEBPACK FOOTER //
// ./src/features/Clock/components/component.js